import React from "react";
import { Link } from "react-router-dom";

export const capitalize = (value) =>
  value ? value.charAt(0).toUpperCase() + value.slice(1) : "";

// Fields shared by the create and edit screens; state and saving stay with
// the page.
const CustomerForm = ({
  inputs,
  options,
  onChange,
  onSubmit,
  saving,
  submitLabel,
  codeHint,
}) => (
  <>
    <div className="coa-panel">
      <div className="coa-panel-head">
        <span>
          <i className="fa fa-user-circle-o me-2"></i>Customer Identity
        </span>
        <span
          className={`coa-pill ${
            inputs.status === "active" ? "coa-pill-dr" : "coa-pill-muted"
          }`}
        >
          {capitalize(inputs.status)}
        </span>
      </div>
      <div className="coa-panel-body">
        <div className="row">
          <div className="col-lg-3">
            <label>
              Code <i className="fa fa-star required"></i>
            </label>
            <input
              type="text"
              className="form-control coa-mono"
              name="code"
              value={inputs.code}
              onChange={onChange}
            />
            {codeHint && <small className="coa-hint">{codeHint}</small>}
          </div>
          <div className="col-lg-7 mg-t-10 mg-lg-t-0">
            <label>
              Name <i className="fa fa-star required"></i>
            </label>
            <input
              type="text"
              className="form-control"
              name="name"
              value={inputs.name}
              onChange={onChange}
              placeholder="Customer or company name"
            />
          </div>
          <div className="col-lg-2 mg-t-10 mg-lg-t-0">
            <label>Status</label>
            <select
              className="form-control"
              name="status"
              value={inputs.status}
              onChange={onChange}
            >
              {options.statuses?.map((status) => (
                <option key={status} value={status}>
                  {capitalize(status)}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </div>

    <div className="coa-panel">
      <div className="coa-panel-head">
        <span>
          <i className="fa fa-address-book-o me-2"></i>Contact Details
        </span>
        <span className="coa-head-note">All optional</span>
      </div>
      <div className="coa-panel-body">
        <div className="row">
          <div className="col-lg-4">
            <label>Contact Person</label>
            <input
              type="text"
              className="form-control"
              name="contact_person"
              value={inputs.contact_person}
              onChange={onChange}
            />
          </div>
          <div className="col-lg-4 mg-t-10 mg-lg-t-0">
            <label>Phone</label>
            <input
              type="text"
              className="form-control"
              name="phone"
              value={inputs.phone}
              onChange={onChange}
            />
          </div>
          <div className="col-lg-4 mg-t-10 mg-lg-t-0">
            <label>Email</label>
            <input
              type="email"
              className="form-control"
              name="email"
              value={inputs.email}
              onChange={onChange}
            />
          </div>
        </div>
        <div className="row mg-t-18">
          <div className="col-lg">
            <label>Address</label>
            <textarea
              className="form-control"
              name="address"
              rows="2"
              value={inputs.address}
              onChange={onChange}
              placeholder="Billing or office address"
            />
          </div>
        </div>
      </div>
    </div>

    <div className="coa-panel">
      <div className="coa-panel-head">
        <span>
          <i className="fa fa-balance-scale me-2"></i>Balances &amp; Credit
        </span>
      </div>
      <div className="coa-panel-body">
        <div className="row">
          <div className="col-lg-3">
            <label>Opening Balance</label>
            <input
              type="number"
              step="0.01"
              className="form-control coa-num"
              name="opening_balance"
              value={inputs.opening_balance}
              onChange={onChange}
              placeholder="0.00"
            />
          </div>
          <div className="col-lg-3 mg-t-10 mg-lg-t-0">
            <label>Credit Limit</label>
            <input
              type="number"
              step="0.01"
              className="form-control coa-num"
              name="credit_limit"
              value={inputs.credit_limit}
              onChange={onChange}
              placeholder="0.00"
            />
          </div>
          <div className="col-lg-3 mg-t-10 mg-lg-t-0">
            <label>Effective Date</label>
            <input
              type="date"
              className="form-control"
              name="effective_date"
              value={inputs.effective_date || ""}
              onChange={onChange}
            />
          </div>
        </div>
        <div className="row mg-t-18">
          <div className="col-lg">
            <label>Remarks</label>
            <textarea
              className="form-control"
              name="description"
              rows="2"
              value={inputs.description || ""}
              onChange={onChange}
              placeholder="Notes about this customer"
            />
          </div>
        </div>
      </div>
    </div>

    <div className="d-flex justify-content-between align-items-center">
      <Link to="/acc-customer" className="btn btn-outline-secondary">
        Cancel
      </Link>
      <button
        type="button"
        className="btn btn-primary"
        onClick={onSubmit}
        disabled={saving}
      >
        <i
          className={`fa ${saving ? "fa-spinner fa-spin" : "fa-send"} mg-r-10`}
        ></i>
        {saving ? "Saving..." : submitLabel}
      </button>
    </div>
  </>
);

export default CustomerForm;
